import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme/';

export default withStyles(() => ({
  messages: {
    width: '100%',
  },
  chatList: {
    width: '100%',
    boxShadow: variables.shadows[1],
    borderRadius: 4,
    background: 'white',
    padding: '16px 0',
  },
  chatHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: 16,
    borderBottom: '1px solid #ddd',
    padding: '0 16px',
    paddingBottom: 16,
  },
  chatSearch: {
    padding: '0 16px',
  },
  loading: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chatContent: {
    width: '100%',
    maxHeight: '65vh',
    minHeight: '65vh',
    overflow: 'auto',
  },
  chatItem: {
    color: '#333',
    fontSize: 14,
    padding: '8px 16px',
    display: 'flex',
    opacity: 0.8,
    alignItems: 'center',
    cursor: 'pointer',
    '&.--not-read': {
      opacity: 1,
    },
    '&.--selected': {
      background: '#f1f1f1',
      opacity: 1,
      '&:hover': {
        background: '#f1f1f1',
      },
    },
    '&:hover': {
      background: '#f9f9f9',
    },
  },
  chatImage: {
    width: 42,
    height: 42,
    backgroundColor: '#eee',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '100%',
    marginRight: 12,
    position: 'relative',
    border: '1px solid #ddd',
    '& span': {
      width: 12,
      height: 12,
      borderRadius: '100%',
      background: '#ccc',
      position: 'absolute',
      top: -2,
      left: 0,
      zIndex: 2,
    },
    '&.--not-read': {
      '& span': {
        backgroundColor: '#087922',
      },
    },
  },
  chatTitle: {
    fontWeight: 500,
    display: 'block',
    marginBottom: 4,
  },
  chatText: {
    color: '#999',
    marginBottom: 4,
    display: 'block',
  },
  chatDate: {
    fontSize: 12,
    color: '#999',
  },
  viewMore: {
    textAlign: 'center',
    color: '#333',
    display: 'block',
    width: '100%',
    padding: 8,
    fontSize: 15,
  },
  badgeAvatar: {
    width: 20,
    height: 20,
    borderRadius: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'absolute',
    bottom: -4,
    right: -4,
    zIndex: 2,
    '&.--hasBadge': {
      backgroundColor: 'white',
    },
  },
  chatEmpty: {
    textAlign: 'center',
    width: '100%',
    fontSize: 14,
    padding: '24px 0',
    color: '#999',
  },
  // chat messages
  chatMessages: {
    background: 'white',
    boxShadow: variables.shadows[1],
    borderRadius: 4,
    padding: 16,
    height: '100%',
  },
  chatMessageWrapper: {
    maxHeight: '64vh',
    minHeight: '64vh',
    position: 'relative',
  },
  chatMessageChat: {
    width: '100%',
    maxHeight: '64vh',
    minHeight: '64vh',
    overflow: 'auto',
    background: '#f9f9f9',
    padding: 20,
    borderRadius: 4,
    position: 'relative',
  },
  chatMessageMessage: {
    width: 'auto',
    maxWidth: '300px',
    borderRadius: 4,
    marginBottom: 12,
    clear: 'both',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 400,
    color: '#fff',
    '&.--producer': {
      float: 'right',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  chatMessageName: {
    color: '#999',
    display: 'block',
    width: '100%',
    fontSize: 13,
  },
  chatMessageContent: {
    width: 'auto',
    maxWidth: '100%',
    padding: '8px 16px',
    background: '#94C2ED',
    display: 'inline-block',
    borderRadius: 5,
    fontWeight: 400,
    position: 'relative',
    wordBreak: 'break-word',
    '&.--producer': {
      background: '#86BB71',
      float: 'right',
      marginBottom: 4,
    },
  },
  chatMessageDate: {
    color: '#92959E',
    width: '100%',
    fontSize: 12,
    marginTop: 4,
    clear: 'both',
    '&.--producer': {
      marginTop: 0,
      textAlign: 'right',
    },
  },
  chatMessageAnswer: {
    width: '100%',
    textAlign: 'right',
  },
  textarea: {
    width: '100%',
    minHeight: '60px',
    borderRadius: '4px',
    resize: 'none',
    border: '1px solid #ced4da',
    padding: '10px 12px',
    fontSize: 15,
    lineHeight: '19px',
    fontWeight: 400,
    color: '#596375',
    transition: '0.3s',
    '&:focus': {
      borderColor: '#a7a7a7',
    },
  },
  chatAnswer: {},
  chatNotSelected: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    fontSize: 14,
  },
  chatActions: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 13,
  },
  // modal new
  modalContent: {},
  // afiliates
  affiliatesActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  affiliatesActionsItems: {
    display: 'inline-block',
    margin: '0 4px',
    fontSize: 13,
    cursor: 'pointer',
    '&:hover': {
      color: variables.palette.primary.main,
    },
  },
  updateChat: {
    width: '100%',
    position: 'absolute',
    bottom: 8,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& small': {
      marginLeft: 8,
      fontSize: 11,
    },
  },
  formControl: {
    width: '100%',
  },
}));
